/**
 * Created by BFR on 08/08/2017.
 */
define('settingDetailView',[
  'module',
  'settingCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!settingDetailTabTpl',
  'colorUtils'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  ColorUtils
) {
  'use strict';

  var SettingDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      templateData.colorHexa = ColorUtils
          .decimalToHexa(this.model.get('matColor'))
          .split('#')[1];
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        settingModel: this.model
      });
      createEditView.show({
        title: _.i18n('customers.edit')
      });
    }

  });

  module.exports = SettingDetailView;
});
